import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal'
import Icons from '../Icons'
import { lightTheme } from '@/customTheme'
import DefaultButton from '@/components/DefaultButton'
import { Z_INDEX } from '@/constants/z-index'
import { useEffect } from 'react'
import { MOBILE_MEDIA_QUERY } from '@/constants/responsive'

function ModalCustom({
  isOpen,
  onOpen,
  onClose,
  content,
  action,
}: {
  isOpen: boolean
  onOpen?: Function
  onClose: Function
  content: {
    header: string
    desc: string
  }
  action: {
    primary: {
      name: string
      handle: Function
      variant?: 'default' | 'gradient' | 'super-gradient'
    }
    secondary?: { name: string; handle: Function }
  }
}) {
  useEffect(() => {
    onOpen?.()
  }, [onOpen])
  return (
    <Modal
      isOpen={isOpen}
      animate
      closeable={true}
      focusLock={false}
      returnFocus={false}
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={{
        Root: {
          style: ({ $theme }) => ({
            display: 'flex',
            flexDirection: 'column',
            zIndex: Z_INDEX.MODAL,
            inset: 0,
          }),
        },
        Dialog: {
          style: ({ $theme, $isVisible, $isOpen }) => ({
            width: '460px',
            [MOBILE_MEDIA_QUERY]: {
              maxWidth: 'calc(100vw - 24px)',
              maxHeight: 'calc(100dvh - 24px)',
              boxSizing: 'border-box',
              overflowY: 'auto',
            },
            // height: '190px',
            padding: '24px',
            ...lightTheme.modal.DialogStyle({ $theme, $isOpen, $isVisible })
          }),
        },
        Backdrop: {
          style: ({ $theme }) => ({
            ...lightTheme.modal.BackdropStyle
          }),
        },
        Close: {
          style: ({ $theme }) => ({
            display: 'none'
          })
        }
      }}
    >
      <ModalHeader
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          // alignItems: 'center',
          margin: '0',
          minHeight: '48px',
          paddingBottom: '16px',
        }}
      >
        <p style={{...lightTheme.typography.Header20bold}}>{content.header}</p>

        <DefaultButton
          icon="iconOnly"
          size="small"
          type="secondary-grey"
          iconComponent={<Icons.Close size={24} />}
          onClick={() => onClose(false)}
        />
      </ModalHeader>
      <ModalBody style={{ display: 'flex', flexDirection: 'row', gap: '10px', margin: '0', fontWeight: 500, color: 'rgba(102, 102, 102, 1)', whiteSpace: 'pre-line' }}>
        {content.desc}
      </ModalBody>
      <ModalFooter
        $style={{
          height: '72px',
          // Longhands, matching baseui's footer defaults key by key so these replace them.
          marginTop: '0',
          marginRight: '0',
          marginBottom: '0',
          marginLeft: '0',
          paddingTop: '0',
          paddingRight: '0',
          paddingBottom: '0',
          paddingLeft: '0',
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'end',
          gap: '8px',
          // Phones stack the actions full width, primary on top.
          [MOBILE_MEDIA_QUERY]: {
            height: 'auto',
            paddingTop: '24px',
            flexDirection: 'column-reverse',
            alignItems: 'stretch',
          },
        }}
      >
        {action.secondary && (
          <DefaultButton
            type="secondary-grey"
            size="standard"
            label={action.secondary.name}
            onClick={() => action.secondary.handle()}
          />
        )}
        {action.primary && (
          <DefaultButton
            type={
              action.primary.variant === 'gradient'
                ? 'primary-gradient'
                : action.primary.variant === 'super-gradient'
                  ? 'super-gradient'
                  : 'primary'
            }
            size="standard"
            label={action.primary.name}
            onClick={() => action.primary.handle()}
          />
        )}
      </ModalFooter>
    </Modal>
  )
}

export default ModalCustom